import React from 'react';
import pluralize from 'pluralize';
import { RibbonIcon } from '../../../../../../wag-react/next-components/icons';
import { Flex, FlexProps } from '../../../../../../wag-react/next-components/Flex';
import { theme } from '../../../../../../wag-react/themes/base-theme';
import { Box } from '../../../../../../wag-react/next-components/box';
import { Typography } from '../../../../../../wag-react/components/Typography';
export type RecommendedInfoProps = {
  numVotes: number;
  recommendationRank: string;
} & FlexProps;
export enum RecommendedText {
  MostRecommended = 'Most Recommended',
  Effective = 'Effective',
  LeastRecommended = 'Least Recommended',
}
export const ComponentConfig = {
  [RecommendedText.MostRecommended]: {
    color: theme.colors.buttermilk,
    Icon: <RibbonIcon width="28px" height="42px" color={theme.colors.buttermilk} />
  },
  [RecommendedText.Effective]: {
    color: 'white',
    Icon: <RibbonIcon width="28px" height="42px" color={[theme.colors.darkGray, 'white']} />
  },
  [RecommendedText.LeastRecommended]: {
    color: theme.colors.backgroundGray,
    Icon: <RibbonIcon width="28px" height="42px" color={[theme.colors.shingleFawn, theme.colors.backgroundGray]} />
  }
};
export const RecommendedInfo = ({
  numVotes,
  recommendationRank,
  ...rest
}: RecommendedInfoProps) => {
  const config = ComponentConfig[recommendationRank];
  let textColor = null;
  let Icon = null;

  // We will usually have a defined config value, but this is added here as a guard
  // in the event that the back-end contract changes and the config above
  // is not reflected yet
  if (!config) {
    textColor = ComponentConfig[RecommendedText.Effective].color;
    Icon = ComponentConfig[RecommendedText.Effective].Icon;
  } else {
    textColor = config.color;
    Icon = config.Icon;
  }
  return <Flex {...rest} data-sentry-element="Flex" data-sentry-component="RecommendedInfo" data-sentry-source-file="index.tsx">
      <Box order={[2, 1]} ml={['8px', 0]} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        <Typography color={[theme.colors.dimGray, textColor]} fontFamily="muliBold" fontSize={['mobile-body1', 'desktop-body1']} m={0} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          {recommendationRank}
        </Typography>
        <Typography color={[theme.colors.dimGray, textColor]} fontSize={['mobile-body2', 'desktop-body2']} m={0} textAlign={['left', 'right']} textTransform="uppercase" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          {`${numVotes} ${pluralize('Vote', numVotes)}`}
        </Typography>
      </Box>
      <Box ml={[0, '8px']} order={[1, 2]} data-sentry-element="Box" data-sentry-source-file="index.tsx">
        {Icon}
      </Box>
    </Flex>;
};